import React from 'react';
import * as _ from 'lodash';

/**
 * @description ロールによって表示、非表示が変化するボタン
 *
 * @param {*} props show:true表示/false非表示, display:スタイル指定
 */
const RoleButton = props => (
  <button
    className={_.defaultTo(props.buttonClass, 'btn')}
    style={{ display: props.show === true ? props.display : 'none' }}
    onClick={props.onClick}
  >
    {props.label}
  </button>
);

RoleButton.defaultProps = {
  display: 'inline-block',
};

export default RoleButton;



// WEBPACK FOOTER //
// ./src/components/button/RoleButton.jsx